module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-7.88da1c9e.jpg";